import React, { useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { CardMedia, Grid, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import ConfirmDeviceModal from './ConfirmDeviceModal';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const CategoryProduct = ({ visible = false, product, setVisible, arrCategory, setRendered }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const [visibleConfirm, setVisibleConfirm] = useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [openCellFlag, setOpenCellFlag] = useState(true);
    const dataProcessIOT = useRef([]);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);
    const openCell = () => {
        if (actionRef.current) return;
        setActionDeviceOnline(true);
        setOpenCellFlag(true);
        actionRef.current = true;
        dataProcessIOT.current = [
            product.cell_id,
            1,
            'exp',
            product.status_action === '1' ? 'etk' : 'ebr',
            product.device_id,
        ];
        let service = serviceList.openCellIOT;
        let inpuVal = [
            product.cabinet_cd,
            product.drawer_lc,
            product.cell_lc.row,
            product.cell_lc.column,
            // dataProcessIOT.current,
        ];
        if (product?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                product.cabinet_cd,
                product.drawer_lc,
                product.cell_lc.row,
                product.cell_lc.column,
                // dataProcessIOT.current,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [
                product.cabinet_cd,
                product.drawer_lc,
                product.cell_lc.column,
                product.column,
                // dataProcessIOT.current,
            ];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunctIOT, 40000, 0);
    };
    const openCellResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setOpenCellFlag(false);
            handleActionDevice();
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
        }
    };
    const closeCell = () => {
        let inpuVal = [product.cabinet_cd, product.drawer_lc, product.cell_lc.row, product.cell_lc.column];
        let service = serviceList.closeCellIOT;
        clearIntervalCheckStatusCell();
        if (product?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [product.cabinet_cd, product.drawer_lc, product.cell_lc.row, product.cell_lc.column];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [product.cabinet_cd, product.drawer_lc, product.cell_lc.column, product.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunctIOT, 40000, 0);
    };
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setVisibleConfirm(false);
            setVisible(false);
        }
        clearIntervalCheckStatusCell();
    };

    const timeOutFunctIOT = (reqInfo) => {
        setActionDeviceOnline(false);
        setOpenCellFlag(false);
        actionRef.current = false;
        toast.error(t('error.time_out') + ': ' + 'IoT');
    };

    const handleActionDevice = () => {
        const InVal = [product.cell_id, 1, 'exp', product.status_action === '1' ? 'etk' : 'ebr', product.device_id];
        sendRequest(
            serviceList.actionDeviceTransaction,
            InVal,
            actionDeviceResult,
            true,
            timeOutFunctActionDevice,
            40000
        );
    };
    const actionDeviceResult = (reqInfoMap, message) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            closeCell();
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleConfirm(true);
            const getSessions = sessionStorage.getItem('category');

            try {
                // const arrCategories = JSON.parse(getSessions);
                const index = arrCategory.indexOf(product);
                if (index >= 0) {
                    arrCategory.splice(index, 1);
                    const arr = arrCategory;
                    sessionStorage.setItem('category', JSON.stringify(arrCategory));
                    setRendered(arr);
                } else {
                }
            } catch (error) {}
        }
    };

    const timeOutFunctActionDevice = (reqInfo) => {
        setActionDeviceOnline(false);
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            closeCell();
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
    };
    // region checkStatusCell END
    return (
        <BootstrapDialog
            style={{ minWidth: '650px', width: '100%' }}
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {product.status_action === '1' ? t('lay_tb') : t('muon_tb')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Loader loading={actionDeviceOnline} />
                <ConfirmDeviceModal
                    visible={visibleConfirm}
                    setVisible={setVisibleConfirm}
                    title={t('comfirm')}
                    handleSave={closeCell}
                />
                <Grid minWidth={'500px'} container spacing={2}>
                    <Grid item xl={6} md={6} sm={6}>
                        <CardMedia
                            component="img"
                            sx={{
                                borderRadius: '5px',
                                boxShadow: (theme) => theme.customShadows.z8,
                                backgroundColor: '#D6E4FF',
                                padding: '10px',
                                width: '100%',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center',

                                objectFit: 'cover',
                            }}
                            image={
                                product?.img_device
                                    ? `${glb_sv.urlGetProductImage(product?.img_device)}`
                                    : `${glb_sv.urlGetProductImage(product?.pic_device)}`
                            }
                            alt={product?.device_nm}
                        />
                    </Grid>
                    <Grid item xl={6} md={6} sm={6}>
                        <Stack spacing={1} sx={{ p: 2 }}>
                            <Link color="inherit" underline="hover">
                                <Typography variant="subtitle1" sx={{ fontSize: '20px', color: 'primary.dark' }} noWrap>
                                    {glb_sv.convertMultipleLanguages(product?.device_nm)}
                                </Typography>
                            </Link>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                                <Typography variant="subtitle2" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('code_DV')}:
                                    </Typography>
                                    &nbsp;
                                    {product?.device_cd}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('cabinet')}:
                                    </Typography>
                                    &nbsp;
                                    {product?.cabinet_nm}
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                                <Typography variant="subtitle2" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('drawer')}:
                                    </Typography>
                                    &nbsp;
                                    {product?.drawer_nm}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('cell')}:
                                    </Typography>
                                    &nbsp;
                                    {`[${product?.cell_lc?.row} : ${product?.cell_lc?.column}]`}
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Typography variant="subtitle1" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('length')}:
                                    </Typography>
                                    &nbsp;
                                    {product?.device_length}
                                </Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" justifyContent="space-between">
                                <Typography variant="subtitle1" sx={{ fontSize: '16px', color: 'text' }}>
                                    <Typography
                                        component="span"
                                        variant="body1"
                                        sx={{
                                            fontSize: '16px',
                                            color: 'text.secondary',
                                        }}
                                    >
                                        {t('size')}:
                                    </Typography>
                                    &nbsp;
                                    {product?.size}
                                </Typography>
                            </Stack>{' '}
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction
                    type={'confirm'}
                    onClick={() => {
                        openCell();
                    }}
                    disabled={openCellFlag}
                    title={product.status_action === '1' ? t('take') : t('borrowing')}
                />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CategoryProduct;
